import { Navigate } from 'react-router';

import { useAuth } from '@/core/auth/use-auth';
import { Landing } from './landing/Landing';

export function LandingRoute() {
    const { isAuthenticated, initialized } = useAuth();

    if (!initialized) return null;

    if (isAuthenticated) {
        return <Navigate to="/app" replace />;
    }

    return <Landing />;
}
